import { render, staticRenderFns } from "./process-manage.vue?vue&type=template&id=171395fa&scoped=true"
import script from "./process-manage.vue?vue&type=script&lang=js"
export * from "./process-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171395fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171395fa')) {
      api.createRecord('171395fa', component.options)
    } else {
      api.reload('171395fa', component.options)
    }
    module.hot.accept("./process-manage.vue?vue&type=template&id=171395fa&scoped=true", function () {
      api.rerender('171395fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flow/process/process-manage.vue"
export default component.exports